import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { FeaturedServices } from '../components/sections/FeaturedServices';
import { ServiceTiers } from '../components/sections/ServiceTiers';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Testimonials } from '../components/sections/Testimonials';
import { CtaBanner } from '../components/sections/CtaBanner';
import { Contact } from '../components/sections/Contact';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full bg-brand-white" data-id="element-224">
      <Header data-id="element-225" />
      <main className="flex-grow w-full" data-id="element-226">
        <Hero data-id="element-227" />
        <About data-id="element-228" />
        <FeaturedServices data-id="element-229" />
        <ServiceTiers data-id="element-230" />
        <WhyChooseUs data-id="element-231" />
        <HowItWorks data-id="element-232" />
        <Testimonials data-id="element-233" />
        <CtaBanner data-id="element-234" />
        <Contact data-id="element-235" />
      </main>
      <Footer data-id="element-236" />
    </div>;
}